import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'tablero',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/presupuesto',
    name: 'presupuesto',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/expedientes/presupuesto.vue'),
  },
  {
    path: '/expediente/modificaciones-lista',
    name: 'expediente-modificaciones',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/expedientes/expediente-modificaciones-lista.vue'),
  },
  {
    path: '/expediente/modificaciones/:id',
    name: 'expediente-modificaciones-formulario',
    props: true,
    meta: {
      authRequired: true,
    },
    component: () => import('./views/expedientes/expediente-modificaciones-formulario.vue'),
  },
  {
    path: '/avance',
    name: 'avance',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/avance/avance'),
  },
  {
    path: '/avance-modificaciones',
    name: 'avance-modificaciones',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/avance/avance-modificaciones.vue'),
  },
  {
    path: '/cuaderno-obra',
    name: 'cuaderno-obra',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/avance/cuaderno-obra'),
  },
  {
    path: '/avance-reportes',
    name: 'avance-reportes',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/avance/avance-reportes.vue'),
  },
  {
    path: '/reportes',
    name: 'reportes',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/reportes/reportes.vue'),
  },
  {
    path: '/curva-s',
    name: 'curva-s',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/reportes/curva-s.vue'),
  },
  {
    path: '/avance-revision',
    name: 'avance',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/avance/avance-revision-lista.vue'),
  },
  {
    path: '/cronograma',
    name: 'cronograma',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/cronograma/cronograma-valorizado'),
  },
    //////
  {
    path: '/finanzas/gastos',
    name: 'Gasos',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/financiero/gastos.vue'),
  },
  {
    path: '/finanzas/pagos',
    name: 'Pagos',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/financiero/pagos.vue'),
  },
  {
    path: '/finanzas/reportes',
    name: 'reportes-finanzas',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/financiero/reportes-finanzas.vue'),
  },
  {
    path: '/finanzas/importar',
    name: 'finanzas-importar',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/financiero/importar.vue'),
  },
  //////
  {
    path: '/almacen/entradas',
    name: 'almacen-entradas',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/almacen/almacen-entradas.vue'),
  },
  {
    path: '/almacen/salidas',
    name: 'almacen-salidas',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/almacen/almacen-salidas.vue'),
  },
  ///////////////////////
  {
    path: '/administracion/usuarios',
    name: 'Usuarios',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/administracion/usuarios-lista'),
  },
  {
    path: '/administracion/usuarios/:id',
    name: 'UsuariosFormulario',
    props: true,
    meta: {
      authRequired: true,
    },
    component: () => import('./views/administracion/usuarios-formulario'),
  },
  {
    path: '/administracion/clasificadores',
    name: 'Clasificadores',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/administracion/clasificadores.vue'),
  },
  {
    path: '/administracion/unidades-medida',
    name: 'Unidades de medida',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/administracion/unidades-medida.vue'),
  },
  {
    path: '/administracion/expedientes',
    name: 'Expedientes',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/administracion/expedientes.vue'),
  },

  {
    path: '/administracion/roles',
    name: 'Roles',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/administracion/roles-lista'),
  },
  {
    path: '/administracion/roles/:id',
    name: 'RolesFormulario',
    props: true,
    meta: {
      authRequired: true,
    },
    component: () => import('./views/administracion/roles-formulario'),
  },


  {
    path: '/login',
    name: 'login',

    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('./views/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },


  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        // Navigate back to previous page, or home as a fallback
        next("/")
      },
    },
  },


]
